import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLoginMutation } from '../services/authApi';
import { setCredentials } from '../store/slices/authSlice';
import type { LoginRequest } from '../types/auth';

export const useAuth = () => {
    const dispatch = useDispatch();
    const [login, { isLoading }] = useLoginMutation();

    const handleLogin = useCallback(async (credentials: LoginRequest) => {
        try {
            const response = await login(credentials).unwrap();
            console.log('response', response);

            const user = response.user;
            const isPatient = user?.role_name?.toLowerCase() === 'customer';
            const isOrgType3 = user?.org_type === 3;

            if (!isPatient && !isOrgType3) {
                return {
                    success: false,
                    error: 'Access denied. You do not have permission to access this resource.',
                };
            }

            dispatch(setCredentials(response));
            return { success: true };
        } catch (error) {
            return {
                success: false,
                error: error instanceof Error ? error.message : 'Invalid email or password',
            };
        }
    }, [dispatch, login]);

    return {
        login: handleLogin,
        isLoading,
    };
};